import {HTMLBase} from '../../html';

export class HTMLTree extends HTMLBase{
    controlType = 'tree';
    treeStructures: any = [];
    constructor(){
        super();
    }
}

export class TreeModel{
    name: string;
    id: string;
    order: number;
    children?: TreeModel[];
    treeId: string;
    parentId?: string;
    rowId: string;
    clickUAID?: string;
  };
